import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const updateModel = async ({ data, model_id }: any) => {
  const response = await fetch(
    `${REACT_APP_VMS_BASE_URL}/quotations/model/${model_id}/upload`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }
  );
  const result = await response.json();
  return result;
};

export default updateModel;
